module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "halftitlepage",
      "id": "bkht"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "i",
      "id": "pi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The Collected Works of F. A. Hayek")]), _vm._v(" "), _c('p', {
    staticClass: "sers",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Volume XIX")]), _vm._v(" "), _c('h1', {
    staticClass: "bkht"
  }, [_vm._v("Law, Legislation, and Liberty")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11bcdbcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-hayek-vol19-0002.vue
// module id = 57
// module chunks = 0